import "./App.css";
import Header from "./components/common/header/Header";
import { BrowserRouter as Router, Route } from "react-router-dom";
import About from "./components/about/About";
import CourseHome from "./components/allcourses/CourseHome";
import Team from "./components/team/Team";
import Pricing from "./components/pricing/Pricing";
import Blog from "./components/blog/Blog";
import Contact from "./components/contact/Contact";
import Home from "./components/home/Home";
import Enroll from "./components/enroll";
import Enrollment from "./components/enrollment";

import React from "react";
import Head from "./components/common/header/Head";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/courses" component={CourseHome} />
        <Route exact path="/team" component={Team} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/journal" component={Blog} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/enroll" component={Enroll} />
        <Route exact path="/enrollment" component={Enrollment} />
      </Router>
    </>
  );
}

export default App;
